import {
  ConfigValue,
  configTypes,
  ConfigActionTypes,
  ErrorValue
} from './types'

const actions = {
  setConfigValue: (payload: ConfigValue): ConfigActionTypes => ({
    type: configTypes.SET_CONFIG_VALUE,
    payload
  }),
  setError: (payload: ErrorValue): ConfigActionTypes => ({
    type: configTypes.SET_ERROR,
    payload
  })
}

export default actions
